import { useCallback } from 'react';
import { find, filter } from 'lodash';
import { useStores } from '@/hooks/use-stores';
import { useInvestigationMetricUrlUpdate } from '@/hooks/useInvestigationMetricUrlUpdate';
import { EXPANDABLE_SECTION_KEYS } from '@/constants/investigationExpandableSections';

export const useInvestigationMetricSelection = () => {
  const { investigationStore } = useStores();
  const { updateMetricInUrl } = useInvestigationMetricUrlUpdate();

  const selectStationMetric = useCallback(
    (metricId: string, isSelected: boolean) => {
      investigationStore.setSelectedStationMetric(metricId, isSelected);

      const metric = find(investigationStore.stationMetrics, { id: metricId });
      if (metric) {
        const stableMetricId = `${EXPANDABLE_SECTION_KEYS.STATION_KPI}:${metric.key}`;
        updateMetricInUrl(stableMetricId, isSelected);
      }
    },
    [investigationStore, updateMetricInUrl],
  );

  const selectDeviceMetric = useCallback(
    (metricId: string, isSelected: boolean) => {
      investigationStore.setSelectedMetric(metricId, isSelected);

      const allDeviceMetrics = filter(
        investigationStore.devicesMetrics,
        device => device.metrics && device.metrics.length > 0,
      ).flatMap(device => device.metrics);
      const metric = find(allDeviceMetrics, { id: metricId });
      if (metric) {
        const stableMetricId = `${metric.deviceId}:${metric.name}`;
        updateMetricInUrl(stableMetricId, isSelected);
      }
    },
    [investigationStore, updateMetricInUrl],
  );

  const selectPressureDrop = useCallback(
    (pressureDropId: string, isSelected: boolean) => {
      investigationStore.setSelectedPressureDrop(pressureDropId, isSelected);

      const pressureDrop = find(investigationStore.pressureDrops, { id: pressureDropId });
      if (pressureDrop) {
        const stableMetricId = `${EXPANDABLE_SECTION_KEYS.PRESSURE_DROP}:${pressureDrop.key}`;
        updateMetricInUrl(stableMetricId, isSelected);
      }
    },
    [investigationStore, updateMetricInUrl],
  );

  return {
    selectStationMetric,
    selectDeviceMetric,
    selectPressureDrop,
  };
};
